import { render, staticRenderFns } from "./LocalisationRoutes.vue?vue&type=template&id=abb44456&"
import script from "./LocalisationRoutes.vue?vue&type=script&lang=ts&"
export * from "./LocalisationRoutes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports